import { render, staticRenderFns } from "./large-ad.vue?vue&type=template&id=01687519&scoped=true&"
import script from "./large-ad.vue?vue&type=script&lang=ts&"
export * from "./large-ad.vue?vue&type=script&lang=ts&"
import style0 from "./large-ad.vue?vue&type=style&index=0&id=01687519&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01687519",
  null
  
)

export default component.exports